import { Suspense, lazy } from 'react'
import { HashRouter, Routes, Route } from 'react-router-dom'
import Home from './pages/Home'

// Carga diferida del editor (y, dentro de él, de la escena 3D): la página de inicio
// no necesita pagar el costo de Three.js/React Three Fiber en el primer render.
const Editor = lazy(() => import('./pages/Editor'))

/**
 * Se utiliza HashRouter en lugar de BrowserRouter porque el despliegue objetivo
 * (Cloudflare Workers con Static Assets, ver README) sirve la aplicación como
 * una SPA de un único archivo estático; el enrutamiento por hash evita depender
 * de reglas adicionales de reescritura de rutas en el servidor.
 */
export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/editor/:projectId"
          element={
            <Suspense
              fallback={
                <div className="flex h-full items-center justify-center text-sm text-[var(--color-ink-soft)]">
                  Cargando editor…
                </div>
              }
            >
              <Editor />
            </Suspense>
          }
        />
      </Routes>
    </HashRouter>
  )
}
